import { useState, useEffect } from 'react';
import { getEstimate } from '../api';

const PLACEHOLDER = '--';

export default function EstimatePanel({ rowCount, totalRows, mode, level, linkedinEngine, overrides, serperPlan, serpapiPlan }) {
  const [estimate, setEstimate] = useState(null);
  const [loading, setLoading] = useState(false);

  const overridesKey = JSON.stringify(overrides || {});
  const hasRows = rowCount && rowCount > 0;

  useEffect(() => {
    if (!hasRows) {
      setEstimate(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    getEstimate(rowCount, mode, level, linkedinEngine, overrides, serperPlan, serpapiPlan)
      .then(data => { if (!cancelled) setEstimate(data); })
      .catch(() => { if (!cancelled) setEstimate(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [rowCount, mode, level, linkedinEngine, overridesKey, serperPlan, serpapiPlan]);

  const costText = !hasRows ? PLACEHOLDER
    : estimate ? (estimate.cost_min === estimate.cost_max ? `$${estimate.cost_min.toFixed(2)}` : estimate.cost_display)
    : PLACEHOLDER;

  const timeText = !hasRows ? PLACEHOLDER
    : estimate ? estimate.time_display
    : PLACEHOLDER;

  const rowsText = hasRows
    ? rowCount.toLocaleString()
    : PLACEHOLDER;

  return (
    <div style={{
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius)',
      padding: '16px 24px',
      marginBottom: 24,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: 'var(--shadow-card)',
      flexWrap: 'wrap',
      gap: 16,
    }}>
      <div style={{ display: 'flex', gap: 32, fontSize: 14, flexWrap: 'wrap', opacity: loading ? 0.5 : 1, transition: 'opacity 0.15s' }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{ color: 'var(--text2)', fontWeight: 500 }}>Rows:</span>
          <span style={{ fontWeight: 700 }}>
            {rowsText}
            {hasRows && totalRows != null && totalRows !== rowCount && (
              <span style={{ color: 'var(--text3)', fontWeight: 400 }}> / {totalRows.toLocaleString()}</span>
            )}
          </span>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{ color: 'var(--text2)', fontWeight: 500 }}>Est. cost:</span>
          <span style={{ fontWeight: 700 }}>{costText}</span>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{ color: 'var(--text2)', fontWeight: 500 }}>Est. time:</span>
          <span style={{ fontWeight: 700 }}>{timeText}</span>
        </div>
      </div>
      {estimate?.stages && (
        <div style={{ fontSize: 12, color: 'var(--text3)' }}>
          {estimate.stages.join(' → ')}
        </div>
      )}
    </div>
  );
}
